import api from 'api';

export const loadOutsourceStudios = api(
  'GET /api/gallery/outsource-studio/list'
);
export const loadOutsourceStudio = api('GET /api/gallery/outsource-studio/:id');
export const createOutsourceStudio = api('POST /api/gallery/outsource-studio');
export const updateOutsourceStudio = api(
  'PUT /api/gallery/outsource-studio/:id'
);
export const deleteOutsourceStudio = api(
  'DELETE /api/gallery/outsource-studio/:id'
);
